// src/i18n/Version.ts
import { createI18n } from 'vue-i18n'
// 导入翻译文件（根据实际项目路径调整）
import zhCN from '@/i18n/locales/zh-CN' // 中文翻译
import enUS from '@/i18n/locales/en-US' // 英文翻译

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 重要：使用 Vue3 的 Composition API 必须设为 false
  locale: 'zh-CN', // 默认语言
  fallbackLocale: 'en-US', // 当翻译缺失时使用的备用语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

export default i18n
